import dayjs from 'dayjs';
import type { ToastMessageOptions } from 'primevue';
export default {
  catchErrorMessage: 'Oops! something went wrong. Please try again later.',
  boatNotEmpty: "Boat is not empty! can't block boat.",
  status: {
    success: 'success',
    fail: 'fail',
    approve: 'approved',
    disapproved: 'disapproved',
    reject: 'Reject',
    active: 'Active',
    inactive: 'Inactive',
    sent: 'Sent',
    delay: 'delay',
    pending: 'pending',
    inProgress: 'inprogress',
    completed: 'completed',
    cancel: 'cancelled',
  },
  leaveStatus: [
    { key: 'Approve', value: 'approved' },
    { key: 'Disapproved', value: 'disapproved' },
    // { key: 'Pending', value: 'pending' },
  ],
  adminLeaveStatus: [
    { key: 'Cancelled', value: 'cancelled' },
  ],
  taskStatusOption: [
    {
      key: 'delay',
      value: 'delay',
    },
    {
      key: 'pending',
      value: 'pending',
    },
    {
      key: 'inprogress',
      value: 'inprogress',
    },
    {
      key: 'completed',
      value: 'completed',
    },
  ],
  priorityOption: [
    {
      key: 'High',
      value: 'hot',
    },
    {
      key: 'Medium',
      value: 'warm',
    },
    {
      key: 'Low',
      value: 'cold',
    },
  ],
  typeOption: [
    {
      key: 'first_half',
      value: 'First Half',
    },
    {
      key: 'second_half',
      value: 'Second Half',
    },
    {
      key: 'full_day',
      value: 'Full Day',
    },
  ],
  priority: {
    hot: 'hot',
    cold: 'cold',
    warm: 'warm',
  },
  filterStatus: [
    {
      key: 'Active',
      value: 'Active',
    },
    {
      key: 'Inactive',
      value: 'InActive',
    },
  ],
  departmentOption: [
    {
      value: 'Engineering',
      key: 'engineering',
    },
    {
      value: 'Human Resource',
      key: 'human_resource',
    },
  ],
  loginSuccessMessage: 'You loggedin successfully.',
  forgotPasswordSuccessMessage: 'Password reset email sent successfully.',
  passwordResetSuccessMessage: 'Password reset successfully.',
  registerSuccessMessage: 'Register successfully. Please verify your email',
  passType: [
    {
      label: 'Daily',
      value: 'Daily',
    },
    {
      label: 'Weekly',
      value: 'Weekly',
    },
    {
      label: 'Monthly',
      value: 'Monthly',
    },
  ],
  serviceType: [
    {
      name: 'Paid',
      id: 'Paid',
    },
    {
      name: 'Un-paid',
      id: 'UnPaid',
    },
  ],
  amountType: [
    {
      label: 'Fixed',
      value: 'fixed',
    },
    {
      label: 'Percentage',
      value: 'percentage',
    },
  ],
  validFor: [
    {
      label: 'For All Users',
      value: 0,
    },
    {
      label: 'For Selected Users',
      value: 1,
    },
  ],
  tripCategory: [
    {
      label: 'General',
      value: 'General',
    },
    {
      label: 'Extra',
      value: 'Extra',
    },
    {
      label: 'Alternate',
      value: 'Alternate',
    },
    {
      label: 'Day wise',
      value: 'Day wise',
    },
  ],
  weekDays: [
    {
      label: 'Sunday',
      value: 'Sunday',
    },
    {
      label: 'Monday',
      value: 'Monday',
    },
    {
      label: 'Tuesday',
      value: 'Tuesday',
    },
    {
      label: 'Wednesday',
      value: 'Wednesday',
    },
    {
      label: 'Thursday',
      value: 'Thursday',
    },
    {
      label: 'Friday',
      value: 'Friday',
    },
    {
      label: 'Saturday',
      value: 'Saturday',
    },
  ],
  role: {
    superAdmin: 'super-admin',
    admin: 'Admin',
    boatOwner: 'Boat Owner',
    portManager: 'Port Manager',
    captain: 'Captain',
    customer: 'Customer',
  },
  passCategory: [
    {
      label: 'Passenger',
      value: 'Passenger',
    },
    {
      label: 'Vehicle',
      value: 'Vehicle',
    },
  ],
  Gender: [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' },
  ],
  proof_type: [
    {
      label: 'Aadhar',
      value: 'aadhar',
    },
    // {
    //   label: 'Passport',
    //   value: 'Passport',
    // },
    {
      label: 'Driving Licence',
      value: 'driving_licence',
    },
    {
      label: 'Student Id',
      value: 'student_id',
    },
  ],
  paymentMethod: {
    online: 'Online',
    cash: 'Cash',
  },
  paginationParams: <paginationParams>{
    limit: 10,
    page: 1,
    sort: 'created_at',
    dir: 'DESC',
    search: '',
    filter: '',
    status: '',
    total: 0,
    perpage: 10,
    from_date: '',
    to_date: '',
    order: 0,
  },
  Months: [
    {
      key: 1,
      value: 'January',
    },
    {
      key: 2,
      value: 'February',
    },
    {
      key: 3,
      value: 'March',
    },
    {
      key: 4,
      value: 'April',
    },
    {
      key: 5,
      value: 'May',
    },
    {
      key: 6,
      value: 'June',
    },
    {
      key: 7,
      value: 'July',
    },
    {
      key: 8,
      value: 'August',
    },
    {
      key: 9,
      value: 'September',
    },
    {
      key: 10,
      value: 'October',
    },
    {
      key: 11,
      value: 'November',
    },
    {
      key: 12,
      value: 'December',
    },
  ],
  toastConfig: <ToastMessageOptions>{
    severity: 'error',
    summary: 'Error',
    detail: 'Oops! something went wrong. Please try again later.',
    life: 3000,
  },
  developedBy: {
    text: 'FinchWeb Technologies',
    url: 'https://www.finchwebtech.com/',
  },
  coprightText: {
    text: `Copyright © ${dayjs('2017').format('YYYY')} - ${dayjs(new Date()).format('YYYY')}  Ashray Infrastructure. All Rights Reserved.`,
    url: import.meta.env.VITE_API_APP_URL,
  },
  modeOption: [
    { key: 'IN', value: 'IN' },
    { key: 'OUT', value: 'OUT' },
  ],
  dayOfWork: {
    fullday: 8,
    halfday: 4,
  },
  employeeType: {
    office: 'office',
    non_office: 'non_office',
  },
  employeeDropDownType: [
    {
      key: 'Office',
      value: 'office',
    },
    {
      key: 'Non Office',
      value: 'non_office',
    },
  ],
};

export interface paginationParams {
  limit: number;
  page: number;
  sort: string | ((item: any) => string) | undefined;
  dir: string | undefined;
  search: string;
  filter: string;
  status: string;
  total: number;
  perpage: number;
  from_date: string;
  to_date: string;
  order: number;
}
interface permissionChildren {
  id: string;
  name: string;
  slug: string;
  created_at: string;
  updated_at: string;
}
export interface Permission {
  id: string;
  name: string;
  slug: string;
  created_at: string;
  updated_at: string;
  permissions: permissionChildren[];
}

interface PermissionCheckBoxChildren {
  key: string;
  label: string;
  data: string;
}
export interface PermissionCheckBox {
  key: string;
  label: string;
  data: string;
  children: PermissionCheckBoxChildren[];
}

export interface taskpriority {
  name: string;
  age: number;
  email?: string; // Optional property
}

export interface WorkingDays {
  id?: string | null;
  year: number | null;
  month: number | null;
  days: number | null;
}

export interface WorkingDaysArr {
  workingdays: WorkingDays[];
}
export interface punchInOutType {
  fromdate: Date | null;
  todate: Date | null;
  employee_id: null | undefined | string;
}

export interface location {
  lat: null | string;
  long: null | string;
}
export interface editPunch {
  punch_time: Date | null | string;
  address: null | string;
  mode: null | string;
  location: location;
  reason?: null | string;
  employee_id: null | string;
}
